const appStoreSearchUrl = term => `https://apps.apple.com/us/search?term=${encodeURIComponent(term)}`;

export const GAMES = [
  {
    slug: 'arrows-puzzle-master',
    title: 'Arrows Puzzle Master',
    shortTitle: 'Arrows',
    route: '/arrows-puzzle-master',
    theme: 'teal',
    accent: '#0ea394',
    accentSoft: '#e7f2f0',
    surface: '#0d2826',
    feature: '/games/arrows-puzzle-master/feature-v9.png',
    icon: '/games/arrows-puzzle-master/icon.png',
    screenshots: [
      '/games/arrows-puzzle-master/screenshots/ss-1.jpeg',
      '/games/arrows-puzzle-master/screenshots/ss-2.jpeg',
      '/games/arrows-puzzle-master/screenshots/ss-3.jpeg',
      '/games/arrows-puzzle-master/screenshots/ss-4.jpeg',
      '/games/arrows-puzzle-master/screenshots/ss-5.jpeg',
    ],
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.puzzle.masters',
    appStoreUrl: 'https://apps.apple.com/us/app/arrows-puzzle-master/id6788788102',
    descriptionEN: 'Release arrows in the right order, untangle collisions, and clear each level on a crisp logic grid.',
    descriptionTR: 'Okları doğru sırayla serbest bırak, çarpışmaları çöz ve her bölümü temiz bir ızgara üzerinde tamamla.',
    highlightsEN: [
      'Clean grid logic with satisfying chain reactions',
      'Animal-themed stage sets and quick sessions',
      'Simple controls with a polished visual style',
    ],
    highlightsTR: [
      'Zincir etkisi veren temiz ızgara mantığı',
      'Hayvan temalı sahneler ve kısa oyun seansları',
      'Kolay kontroller ve parlak, düzenli bir görünüm',
    ],
    howToPlayEN: [
      'Examine Arrow Directions: Identify each arrow’s trajectory and potential path blocks.',
      'Choose the Right Order: Tap the arrow that has a clear path out of the board.',
      'Trigger Chain Reactions: Clear blocking arrows to unlock paths for the remaining pieces.',
    ],
    howToPlayTR: [
      'Ok Yönlerini İncele: Tahtadaki okların hareket yönünü ve engelleri tespit et.',
      'Doğru Sırayı Seç: Çarpışma olmadan dışarı kaçabilecek ilk oku tıkla.',
      'Zincirleme Tepkileri Aç: Yol açıldıkça diğer okları serbest bırak ve bölümü temizle.',
    ],
    featuresEN: [
      { title: '1,000+ Brain Levels', desc: 'Handcrafted logic challenges with scaling difficulty and unique obstacles.' },
      { title: 'Animal Collections', desc: 'Unlock adorable animal avatars and custom grid themes as you progress.' },
      { title: 'Offline Mode', desc: 'Play anytime, anywhere without requiring an active internet connection.' },
      { title: 'Satisfying FX', desc: 'Crisp tactile haptics and smooth arrow release animations.' },
    ],
    featuresTR: [
      { title: '1.000+ Mantık Seviyesi', desc: 'Özel olarak tasarlanmış, zeka geliştiren ve aşamalı zorlaşan bulmacalar.' },
      { title: 'Hayvan Koleksiyonları', desc: 'Seviye atladıkça sevimli hayvan temalarını ve özel ızgara stillerini açın.' },
      { title: 'Çevrimdışı Oynama', desc: 'İnternet bağlantısına ihtiyaç duymadan istediğiniz her yerde rahatça oynayın.' },
      { title: 'Tatmin Edici Animasyonlar', desc: 'Okların akıcı bir şekilde süzülüşünü ve dokunsal geri bildirimleri hissedin.' },
    ],
    tipsEN: [
      'Look for outer arrows with zero obstacles blocking their forward vector.',
      'Plan 2-3 moves ahead to avoid creating deadlock situations.',
      'Use the Undo booster if you tap a trapped arrow by mistake.',
    ],
    tipsTR: [
      'Önünde hiç engel bulunmayan dış kenar oklarını ilk önce temizleyin.',
      'Kilitlenmeleri önlemek için 2-3 hamle sonrasını zihninizde canlandırın.',
      'Yanlış bir oka tıkladığınızda Geri Al jokerini kullanarak hamleyi düzeltin.',
    ],
    faqEN: [
      { q: 'Is Arrows Puzzle Master free to play?', a: 'Yes! The core game is completely free with optional hints available.' },
      { q: 'Can I play without WiFi?', a: 'Absolutely, all levels are available offline.' },
    ],
    faqTR: [
      { q: 'Arrows Puzzle Master ücretsiz mi?', a: 'Evet! Oyun tamamen ücretsizdir ve isteğe bağlı joker desteği sunar.' },
      { q: 'İnternetsiz oynanabilir mi?', a: 'Kesinlikle, tüm bölümler çevrimdışı oynanabilir.' },
    ],
  },
  {
    slug: 'block-boom',
    title: 'Block Boom!',
    shortTitle: 'Boom',
    route: '/block-boom',
    theme: 'violet',
    accent: '#8b5cf6',
    accentSoft: '#f1ecff',
    surface: '#251b52',
    feature: '/games/block-boom/feature.png',
    icon: '/games/block-boom/icon.png',
    screenshots: [
      '/games/block-boom/screenshots/ss-1.jpeg',
      '/games/block-boom/screenshots/ss-2.jpeg',
      '/games/block-boom/screenshots/ss-3.jpeg',
      '/games/block-boom/screenshots/ss-4.jpeg',
      '/games/block-boom/screenshots/ss-5.jpeg',
    ],
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.blocks.boom',
    appStoreUrl: 'https://apps.apple.com/us/app/blocks-boom/id6791165161',
    descriptionEN: 'Drop colorful blocks, finish rows and columns, and keep the combo meter glowing.',
    descriptionTR: 'Renkli blokları yerleştir, satır ve sütunları tamamla, komboları alevlendirmeye devam et.',
    highlightsEN: [
      'Bright block art with explosive clear effects',
      'Combo-friendly layout for fast sessions',
      'A polished arcade feel built for stores',
    ],
    highlightsTR: [
      'Patlama hissi veren parlak blok görselleri',
      'Hızlı oyun için komboya uygun düzen',
      'Mağazalara uygun, cilalı bir arcade deneyimi',
    ],
    howToPlayEN: [
      'Drag & Place Blocks: Position 3 offered shapes onto the grid to form complete lines.',
      'Clear Full Lines: Complete vertical or horizontal lines to trigger satisfying blasts.',
      'Build Combo Streaks: Clear lines in consecutive moves to double and triple your score.',
    ],
    howToPlayTR: [
      'Blokları Tahtaya Sürükle: Verilen 3 farklı şekli ızgaraya stratejik olarak yerleştir.',
      'Satır ve Sütunları Tamamla: Dolu çizgileri patlatıp tahtada yer açın.',
      'Kombo Sayacını Yükselt: Üst üste patlatmalar yaparak katlamalı skor kazanın.',
    ],
    featuresEN: [
      { title: 'Endless & Level Modes', desc: 'Enjoy relaxing high-score chases or structured stage puzzles.' },
      { title: 'Explosive Combos', desc: 'Visual explosion animations and high-energy audio effects.' },
      { title: 'Brain Training', desc: 'Keeps spatial awareness sharp while offering stress-free fun.' },
      { title: 'Lightweight & Fast', desc: 'Loads instantly on any device with zero lag.' },
    ],
    featuresTR: [
      { title: 'Sonsuz ve Seviye Modları', desc: 'Hem rekor kırma modunda hem de kademeli seviye modunda oynayın.' },
      { title: 'Patlamalı Kombolar', desc: 'Göz alıcı efektler ve coşkulu seslerle kombo heyecanını yaşayın.' },
      { title: 'Zihin Egzersizi', desc: 'Mekansal farkındalığı artırırken stresi azaltan eğlenceli yapı.' },
      { title: 'Hızlı ve Hafif', desc: 'Tüm cihazlarda anında açılır, takılmadan akıcı çalışır.' },
    ],
    tipsEN: [
      'Always leave a 3x3 empty square for larger block shapes.',
      'Prioritize clearing multiple lines at once for huge combo multipliers.',
      'Don’t pack blocks into corners without leaving exit routes.',
    ],
    tipsTR: [
      'Büyük 3x3 bloklar için tahtada her zaman boş alan bırakmaya özen gösterin.',
      'Aynı anda birden fazla satırı patlatmaya çalışarak kombo puanı katlayın.',
      'Köşeleri tıkamadan dengeli bir dağılım tercih edin.',
    ],
    faqEN: [
      { q: 'Is there a time limit per level?', a: 'No, play at your own pace with unlimited thinking time.' },
      { q: 'Can I play offline?', a: 'Yes, Block Boom supports full offline gameplay.' },
    ],
    faqTR: [
      { q: 'Zaman sınırı var mı?', a: 'Hayır, hamlelerinizi istediğiniz kadar düşünerek yapabilirsiniz.' },
      { q: 'Çevrimdışı oynayabilir miyim?', a: 'Evet, internetsiz olarak keyifle oynayabilirsiniz.' },
    ],
  },
  {
    slug: 'cars-puzzle-escape',
    title: 'Cars - Puzzle Escape',
    shortTitle: 'Cars',
    route: '/car-puzzle',
    theme: 'blue',
    accent: '#0f5cab',
    accentSoft: '#eaf4fb',
    surface: '#082f51',
    feature: '/games/cars-puzzle-escape/feature.png',
    icon: '/games/cars-puzzle-escape/icon.png',
    screenshots: [
      '/games/cars-puzzle-escape/screenshots/ss-1.png',
      '/games/cars-puzzle-escape/screenshots/ss-2.png',
      '/games/cars-puzzle-escape/screenshots/ss-3.png',
      '/games/cars-puzzle-escape/screenshots/ss-4.png',
      '/games/cars-puzzle-escape/screenshots/ss-5.png',
    ],
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.puzzle.trafficescape',
    appStoreUrl: 'https://apps.apple.com/us/app/cars-puzzle-escape/id6790754783',
    descriptionEN: 'Tap cars out of the lot, untangle traffic jams, and chase a clean escape route.',
    descriptionTR: 'Arabaları otoparktan çıkar, trafiği çöz ve temiz bir kaçış hattı yakala.',
    highlightsEN: [
      'Traffic-puzzle look with smooth road layouts',
      'Relaxing but brainy parking-lot challenges',
      'A strong store-ready hero image and icon',
    ],
    highlightsTR: [
      'Yol düzeniyle zenginleşen trafik bulmacası hissi',
      'Rahatlatıcı ama düşündürücü otopark bölümleri',
      'Mağaza için hazır güçlü bir görsel dil',
    ],
    howToPlayEN: [
      'Inspect Traffic Gridlock: Observe vehicle orientations and arrow directions.',
      'Tap to Drive Out: Tap vehicles facing clear exits to move them into the main road.',
      'Evacuate All Cars: Clear every single vehicle out of the congested lot to win.',
    ],
    howToPlayTR: [
      'Otoparkı İnceleyin: Araçların yönünü ve kaçış yollarındaki engelleri belirleyin.',
      'Tıklayıp Yola Çıkarın: Önü açık olan araçlara dokunarak otoparktan tahliye edin.',
      'Tüm Araçları Boşaltın: Kazasız bir şekilde tüm araçları çıkararak bölümü geçin.',
    ],
    featuresEN: [
      { title: 'Challenging Parking Jam', desc: 'Dozens of car types, buses, and special emergency vehicles.' },
      { title: 'Smooth Car Physics', desc: 'Satisfying drive-away animations with realistic sound effects.' },
      { title: 'Helicopter & Tow Boosters', desc: 'Stuck in a heavy jam? Call in special utility vehicles for help.' },
      { title: 'Offline Friendly', desc: 'Play on commutes or flights without internet.' },
    ],
    featuresTR: [
      { title: 'Zorlu Trafik Bulmacaları', desc: 'Farklı boyutta arabalar, otobüsler ve özel engeller.' },
      { title: 'Akıcı Sürüş Hissi', desc: 'Tatmin edici araç hareketleri ve gerçekçi motor/kornalar.' },
      { title: 'Helikopter ve Çekici Jokerleri', desc: 'Sıkıştığınız anlarda özel destek araçlarını çağırın.' },
      { title: 'İnternetsiz Oynama', desc: 'Yolculuklarda veya internetsiz ortamlarda kesintisiz eğlence.' },
    ],
    tipsEN: [
      'Start with vehicles closest to the outer boundary roads.',
      'Look out for ambulances and buses that require wider exit lanes.',
      'Work backwards from the main highway exit to trace open lines.',
    ],
    tipsTR: [
      'Dış yollara en yakın duran araçlardan başlayarak yolu genişletin.',
      'Otobüs ve uzun araçların geçiş yönüne öncelik tanıyın.',
      'Ana çıkış kapısından geriye doğru iz sürerek kilit noktaları çözün.',
    ],
    faqEN: [
      { q: 'Can I undo a car move?', a: 'Yes, use the Undo button to reverse your last vehicle tap.' },
      { q: 'Does it support iOS and Android?', a: 'Yes, available on both App Store and Google Play.' },
    ],
    faqTR: [
      { q: 'Hamlemi geri alabilir miyim?', a: 'Evet, Geri Al butonunu kullanarak araç hareketini geri döndürebilirsiniz.' },
      { q: 'Android ve iOS destekli mi?', a: 'Evet, hem App Store hem Google Play’de yayında.' },
    ],
  },
  {
    slug: 'blocks-puzzle-escape',
    title: 'Blocks - Puzzle Escape',
    shortTitle: 'Escape',
    route: '/blocks-puzzle-escape',
    theme: 'indigo',
    accent: '#1f7cff',
    accentSoft: '#e9f4ff',
    surface: '#0f2442',
    feature: '/games/blocks-puzzle-escape/feature.png',
    icon: '/games/blocks-puzzle-escape/icon.png',
    screenshots: [
      '/games/blocks-puzzle-escape/screenshots/ss-1.jpg',
      '/games/blocks-puzzle-escape/screenshots/ss-2.jpg',
      '/games/blocks-puzzle-escape/screenshots/ss-3.jpg',
      '/games/blocks-puzzle-escape/screenshots/ss-4.jpg',
      '/games/blocks-puzzle-escape/screenshots/ss-5.jpg',
    ],
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.puzzle.blockescape',
    appStoreUrl: appStoreSearchUrl('Blocks Puzzle Escape'),
    descriptionEN: 'Unlock the path, solve locked blocks, and keep the escape route clean.',
    descriptionTR: 'Yolu aç, kilitli blokları çöz ve kaçış hattını tertemiz tut.',
    highlightsEN: [
      'Blue, crisp visuals built around the escape path',
      'Satisfying block placement and clear states',
      'Designed to sit beside the other puzzle brands',
    ],
    highlightsTR: [
      'Kaçış hattı etrafında kurulu net mavi görseller',
      'Tatmin edici blok yerleşimi ve temizleme anları',
      'Diğer bulmaca markalarıyla uyumlu konumlandırma',
    ],
    howToPlayEN: [
      'Focus on the Target Block: Locate the main highlighted escape block.',
      'Slide Surrounding Obstacles: Move horizontal blocks sideways and vertical blocks up/down.',
      'Reach the Exit Gate: Create a clear corridor to slide the target block out of the grid.',
    ],
    howToPlayTR: [
      'Hedef Bloğu Belirleyin: Çıkışa ulaşması gereken özel renkli bloğu hedefleyin.',
      'Engelleri Kaydırın: Yatay blokları sağa/sola, dikey blokları yukarı/aşağı kaydırın.',
      'Kapıya Ulaşın: Hedef bloğun önüne açık koridor oluşturup dışarı çıkarın.',
    ],
    featuresEN: [
      { title: 'Classic Unblock Gameplay', desc: 'Timeless logic puzzle mechanic reimagined with sleek modern aesthetics.' },
      { title: '3 Star Rating System', desc: 'Solve puzzles in the fewest moves possible to collect all stars.' },
      { title: 'Hint & Reset Controls', desc: 'Get step-by-step guidance whenever you get stuck.' },
      { title: 'Minimalist & Calm', desc: 'No timer pressure, serene soundscapes, and crisp visual feedback.' },
    ],
    featuresTR: [
      { title: 'Klasik Blok Açma Mantığı', desc: 'Modern dokunuşlarla yenilenmiş zamansız kaydırmalı bulmaca.' },
      { title: '3 Yıldızlı Değerlendirme', desc: 'Bölümleri en az hamle ile tamamlayarak tüm yıldızları toplayın.' },
      { title: 'İpucu ve Sıfırlama', desc: 'Zorlandığınızda adım adım ipucu alarak çözüme ulaşın.' },
      { title: 'Sade ve Huzurlu', desc: 'Süre baskısı yok, rahatlatıcı efektler ve net tasarım.' },
    ],
    tipsEN: [
      'Focus on freeing vertical blocks that directly block horizontal sliders.',
      'Don’t rush; count grid spaces before sliding long blocks.',
    ],
    tipsTR: [
      'Öncelikle dikey blokları aşağı/yukarı kaydırarak yatay yolları açmaya çalışın.',
      'Acele etmeden hamle sayınızı tasarruflu kullanın.',
    ],
    faqEN: [
      { q: 'How many stages are included?', a: 'Over 500+ stages across Easy, Medium, Hard, and Expert difficulties.' },
      { q: 'Is it completely free?', a: 'Yes, free to play with optional hint rewards.' },
    ],
    faqTR: [
      { q: 'Kaç bölüm var?', a: 'Kolay, Orta, Zor ve Uzman seviyelerinde 500’den fazla bölüm içerir.' },
      { q: 'Ücretsiz mi?', a: 'Evet, tamamen ücretsizdir.' },
    ],
  },
  {
    slug: 'nonogram',
    title: 'Nonogram',
    shortTitle: 'Nonogram',
    route: '/nonogram',
    theme: 'ocean',
    accent: '#0f7fb6',
    accentSoft: '#eaf6fb',
    surface: '#06263b',
    feature: '/games/nonogram/feature.png',
    icon: '/games/nonogram/icon.png',
    screenshots: [
      '/games/nonogram/screenshots/ss-1.png',
      '/games/nonogram/screenshots/ss-2.png',
      '/games/nonogram/screenshots/ss-3.png',
      '/games/nonogram/screenshots/ss-4.png',
      '/games/nonogram/screenshots/ss-5.png',
      '/games/nonogram/screenshots/ss-6.png',
    ],
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.nonogram.pixelpuzzle',
    appStoreUrl: appStoreSearchUrl('Nonogram Puzzle'),
    descriptionEN: 'Reveal pictures cell by cell with a calm, ocean-blue nonogram layout.',
    descriptionTR: 'Sakin, okyanus tonlarında bir nonogram düzeniyle resimleri tek tek ortaya çıkar.',
    highlightsEN: [
      'Picture logic puzzle presentation',
      'Gentle color palette and clean grid lines',
      'A relaxing puzzle page for store browsing',
    ],
    highlightsTR: [
      'Resim mantığına dayalı bulmaca sunumu',
      'Sakin renk paleti ve temiz ızgara çizgileri',
      'Mağaza gezintisi için rahatlatıcı bir sayfa',
    ],
    howToPlayEN: [
      'Check Header Clues: Numbers along headers indicate lengths of consecutive filled tiles.',
      'Fill & Mark Cells: Tap to fill valid cells or mark empty ones with X.',
      'Reveal Pixel Art: Fill the grid correctly to unlock a beautiful hidden illustration.',
    ],
    howToPlayTR: [
      'İpuçlarını Okuyun: Satır ve sütunlardaki sayılar peş peşe kaç kutunun boyanacağını gösterir.',
      'Kutuları İşaretleyin: Kesin doldurulacak kutuları boyayın, boş kutulara X koyun.',
      'Piksel Sanatını Açın: Tüm bulmaca bittiğinde gizli harika resmi görün.',
    ],
    featuresEN: [
      { title: 'Daily Puzzles', desc: 'A brand new picture logic challenge every single day.' },
      { title: 'Streaks & Trophies', desc: 'Build daily play streaks and collect seasonal gallery rewards.' },
      { title: '14 Languages', desc: 'Fully localized experience available in 14 major global languages.' },
      { title: 'Auto-Cross & Smart Hints', desc: 'Smart assistant features to help complete rows effortlessly.' },
    ],
    featuresTR: [
      { title: 'Günlük Bulmacalar', desc: 'Her gün yeni bir piksel resmi açma heyecanı.' },
      { title: 'Seri ve Kupalar', desc: 'Günlük seriler oluşturarak koleksiyon albümünüzü tamamlayın.' },
      { title: '14 Dil Desteği', desc: 'Türkçe dahil geniş dil desteği ile erişilebilir deneyim.' },
      { title: 'Akıllı İpuçları', desc: 'Tamamlanan satırlarda otomatik çarpı koyma ve yardım özellikleri.' },
    ],
    tipsEN: [
      'Start with rows/columns where the number matches or nearly matches the grid width.',
      'Always mark empty spaces with X to narrow down uncertain cells.',
    ],
    tipsTR: [
      'Öncelikle toplamı ızgara genişliğine eşit olan satırlardan boyamaya başlayın.',
      'Emin olduğunuz boşluklara X koyarak ihtimalleri daraltın.',
    ],
    faqEN: [
      { q: 'What size grids are available?', a: 'Grids range from easy 5x5 up to complex 20x20 picture challenges.' },
      { q: 'Is my progress saved online?', a: 'Yes, your completed galleries are stored on your device.' },
    ],
    faqTR: [
      { q: 'Hangi boyutlarda ızgaralar var?', a: '5x5 kolay seviyelerden 20x20 detaylı piksel haritalarına kadar.' },
      { q: 'İlerlemem kaydediliyor mu?', a: 'Evet, tüm çözülmüş resim galeriniz kaydedilir.' },
    ],
  },
  {
    slug: 'minesweeper',
    title: 'Minesweeper: Mine Quest',
    shortTitle: 'Mine Quest',
    route: '/minesweeper',
    theme: 'slate',
    accent: '#475569',
    accentSoft: '#eef2f7',
    surface: '#0f172a',
    feature: '/games/minesweeper/feature.png',
    icon: '/games/minesweeper/icon.png',
    screenshots: [
      '/games/minesweeper/screenshots/ss-1.png',
      '/games/minesweeper/screenshots/ss-2.png',
      '/games/minesweeper/screenshots/ss-3.png',
      '/games/minesweeper/screenshots/ss-4.png',
      '/games/minesweeper/screenshots/ss-5.png',
    ],
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.minequest.minesweeper',
    appStoreUrl: appStoreSearchUrl('Minesweeper Mine Quest'),
    descriptionEN: 'Clear the field with classic logic, clean icons, and a modern mine-quest look.',
    descriptionTR: 'Klasik mantıkla alanı temizle, modern ikonlar ve sade bir mine-quest görünümü kullan.',
    highlightsEN: [
      'Classic minefield logic with a modern polish',
      'Strong contrast for quick reading on mobile',
      'A familiar game with a fresh store image',
    ],
    highlightsTR: [
      'Modernleştirilmiş klasik mayın tarlası mantığı',
      'Mobilde hızlı okuma için güçlü kontrast',
      'Tanıdık oyuna taze bir mağaza görseli',
    ],
    howToPlayEN: [
      'Tap to Reveal: Tap safe tiles to reveal numbers indicating nearby hidden mines.',
      'Flag Suspected Mines: Long-press or switch to flag mode to isolate hidden mines.',
      'Clear the Board: Open every single non-mine tile on the board to win.',
    ],
    howToPlayTR: [
      'Kareleri Açın: Güvenli karelere tıklayın, çıkan rakamlar komşu mayın sayısını gösterir.',
      'Mayınları Bayrakla İşaretleyin: Uzun basarak veya bayrak moduna geçerek mayınları işaretleyin.',
      'Alanı Temizleyin: Mayınlara dokunmadan tüm güvenli alanları açıp zafer kazanın.',
    ],
    featuresEN: [
      { title: 'First Tap Safety', desc: 'Guaranteed safety on your very first click so you never hit a mine instantly.' },
      { title: 'Multiple Difficulties', desc: 'Beginner, Intermediate, Expert, and custom board dimensions.' },
      { title: 'Statistics & Timers', desc: 'Track your fastest clear times and win-rate statistics.' },
      { title: 'Clean Modern UI', desc: 'Crisp vector icons and smooth zooming controls.' },
    ],
    featuresTR: [
      { title: 'İlk Dokunuş Güvencesi', desc: 'İlk hamlenizde asla mayına basmama garantisi.' },
      { title: 'Çeşitli Zorluk Dereceleri', desc: 'Acemi, Orta, Uzman ve özel boyutlu alan seçenekleri.' },
      { title: 'Detaylı İstatistikler', desc: 'En hızlı sürelerinizi ve kazanma oranlarınızı takip edin.' },
      { title: 'Modern Arayüz', desc: 'Net ikonlar, rahat yakınlaştırma ve dokunsal geri bildirim.' },
    ],
    tipsEN: [
      'Look for numbers with equal remaining unrevealed neighbor tiles.',
      'Use chord clicking (tapping numbers with correct surrounding flags) to clear fast.',
    ],
    tipsTR: [
      'Kalan kapalı komşu sayısı üzerindeki rakama eşit olan yerlere hemen bayrak koyun.',
      'Hızlı temizlik yapmak için rakamlara çift dokunarak komşu kareleri açın.',
    ],
    faqEN: [
      { q: 'Can I play offline?', a: 'Yes, no internet required.' },
      { q: 'Are there ads?', a: 'Minimal, unintrusive ad placement for uninterrupted logic solving.' },
    ],
    faqTR: [
      { q: 'İnternet gerekiyor mu?', a: 'Hayır, tamamen çevrimdışı oynanabilir.' },
      { q: 'Zorluk özelleştirilebilir mi?', a: 'Evet, özel harita boyutları oluşturabilirsiniz.' },
    ],
  },
  {
    slug: 'word-search',
    title: 'Word Search',
    shortTitle: 'Words',
    route: '/word-search',
    theme: 'amber',
    accent: '#d97706',
    accentSoft: '#fff6df',
    surface: '#2e1c05',
    feature: '/games/word-search/feature.png',
    icon: '/games/word-search/icon.png',
    screenshots: [
      '/games/word-search/screenshots/ss-1.png',
      '/games/word-search/screenshots/ss-2.png',
      '/games/word-search/screenshots/ss-3.png',
      '/games/word-search/screenshots/ss-4.png',
      '/games/word-search/screenshots/ss-5.png',
    ],
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.mkucukkoc.wordsearch',
    appStoreUrl: appStoreSearchUrl('Word Search'),
    descriptionEN: 'Trace words across calm puzzle boards, with easy readability and classic word-hunt comfort.',
    descriptionTR: 'Kelime avı panolarında kelimeleri işaretle; okunaklı, rahat ve klasik bir deneyim.',
    highlightsEN: [
      'Simple word-hunt structure with strong readability',
      'Perfect for casual play sessions and long sessions',
      'Store-ready visuals with a warm, paper-like tone',
    ],
    highlightsTR: [
      'Güçlü okunaklılığa sahip sade kelime avı yapısı',
      'Hem kısa hem uzun oyun seanslarına uygun',
      'Sıcak, kağıt hissi veren mağaza görselleri',
    ],
    howToPlayEN: [
      'View Word List: Check target words listed at the bottom of your screen.',
      'Swipe to Connect: Trace letters vertically, horizontally, or diagonally in any direction.',
      'Clear the Board: Highlight all words to complete the level and expand your vocabulary.',
    ],
    howToPlayTR: [
      'Kelime Listesine Bakın: Ekranın altında sıralanan hedef kelimeleri inceleyin.',
      'Parmağınızla Çizin: Harfleri yatay, dikey veya çapraz olarak birleştirin.',
      'Panoyu Tamamlayın: Tüm kelimeleri bularak seviyeyi geçin ve kelime haznenizi genişletin.',
    ],
    featuresEN: [
      { title: 'Thousands of Categories', desc: 'Food, Animals, Countries, Science, Sports, and more.' },
      { title: 'Relaxing Atmosphere', desc: 'Calm ambient music and warm aesthetic color schemes.' },
      { title: 'Multi-Language Vocabulary', desc: 'Expand your word skills in English, Turkish, Spanish, German & more.' },
      { title: 'Daily Word Quest', desc: 'Solve unique daily challenges for bonus rewards.' },
    ],
    featuresTR: [
      { title: 'Binlerce Kategori', desc: 'Hayvanlar, Coğrafya, Yemekler, Spor, Bilim ve çok daha fazlası.' },
      { title: 'Dinlendirici Tema', desc: 'Sıcak kağıt tonları, gözü yormayan renkler ve rahatlatıcı müzik.' },
      { title: 'Çoklu Dil Desteği', desc: 'Türkçe, İngilizce ve diğer dillerde kelime dağarcığınızı geliştirin.' },
      { title: 'Günlük Kelime Avı', desc: 'Her gün yenilenen özel ödüllü kelime bulmacaları.' },
    ],
    tipsEN: [
      'Look for rare letters like Z, Q, or X first to locate word starting positions quickly.',
      'Scan row by row if you get stuck on the final remaining word.',
    ],
    tipsTR: [
      'Nadir bulunan harflere (Örn: J, Z, V) odaklanarak kelimenin yerini hızlıca tespit edin.',
      'Son kelimede zorlandığınızda panoyu satır satır tarayın.',
    ],
    faqEN: [
      { q: 'Is this game suitable for kids?', a: 'Yes, excellent educational puzzle for all age groups.' },
      { q: 'Can I change font size?', a: 'Yes, text automatically scales for maximum legibility.' },
    ],
    faqTR: [
      { q: 'Çocuklar için uygun mu?', a: 'Evet, her yaş grubu için kelime geliştirici harika bir oyun.' },
      { q: 'İnternetsiz çalışıyor mu?', a: 'Evet, tam çevrimdışı oynanabilir.' },
    ],
  },
  {
    slug: 'sudoku',
    title: 'Sudoku Quest',
    shortTitle: 'Sudoku',
    route: '/sudoku',
    theme: 'purple',
    accent: '#7c3aed',
    accentSoft: '#f3ecff',
    surface: '#21123b',
    feature: '/games/sudoku/feature.png',
    icon: '/games/sudoku/icon.png',
    screenshots: [
      '/games/sudoku/screenshots/ss-1.png',
      '/games/sudoku/screenshots/ss-2.png',
      '/games/sudoku/screenshots/ss-3.png',
      '/games/sudoku/screenshots/ss-4.png',
      '/games/sudoku/screenshots/ss-5.png',
    ],
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.mkucukkoc.sudokuquest',
    appStoreUrl: 'https://apps.apple.com/app/id6795449818',
    descriptionEN: 'A clean sudoku experience with crisp number grids and a focused, premium-feeling presentation.',
    descriptionTR: 'Net sayı ızgaraları ve premium his veren sade bir sudoku deneyimi.',
    highlightsEN: [
      'Classic sudoku boards with a polished look',
      'Strong contrast and a calm blue-purple palette',
      'Direct iOS and Android store access buttons',
    ],
    highlightsTR: [
      'Parlak görünümlü klasik sudoku panoları',
      'Güçlü kontrast ve sakin mavi-mor palet',
      'Doğrudan iOS ve Android mağaza bağlantıları',
    ],
    howToPlayEN: [
      'Fill 9x9 Grid: Place numbers 1 through 9 into empty board cells.',
      'Check Constraints: Ensure each row, column, and 3x3 block has no repeating numbers.',
      'Utilize Pencil Mode: Write small candidate notes to organize logical steps.',
    ],
    howToPlayTR: [
      '9x9 Izgarayı Doldurun: Boş kutulara 1’den 9’a kadar rakamları yerleştirin.',
      'Kurallara Uyun: Her satır, sütun ve 3x3 kutuda sayılar sadece bir kez kullanılabilir.',
      'Not Alma Modunu Kullanın: İhtimalleri küçük notlar olarak yazıp stratejinizi kurun.',
    ],
    featuresEN: [
      { title: '4 Difficulty Tiers', desc: 'Easy, Medium, Hard, and Expert levels for all skill ranges.' },
      { title: 'Auto-Highlighting', desc: 'Highlights duplicate numbers and matching rows for quick reading.' },
      { title: 'Unlimited Undo & Eraser', desc: 'Correct mistakes instantly without penalty.' },
      { title: 'Night & Eye-Care Themes', desc: 'Comfortable dark mode interface for evening puzzle sessions.' },
    ],
    featuresTR: [
      { title: '4 Zorluk Seviyesi', desc: 'Kolay, Orta, Zor ve Uzman modları ile her seviyeye uygun.' },
      { title: 'Akıllı Vurgulama', desc: 'Aynı sayıları ve ilgili satır/sütunu otomatik renklendirir.' },
      { title: 'Sınırsız Geri Al', desc: 'Hataları anında silip düzeltme imkanı.' },
      { title: 'Gece Modu Tasarımı', desc: 'Gözü yormayan şık mor-koyu renk paleti.' },
    ],
    tipsEN: [
      'Focus on rows or 3x3 boxes that already have 6+ numbers filled in.',
      'Use pencil notes systematically to eliminate impossible placements.',
    ],
    tipsTR: [
      'Öncelikle 6 veya daha fazla sayısı dolmuş olan satır ve kutulara odaklanın.',
      'Not alma özelliğini etkin kullanarak aday sayıları eleyin.',
    ],
    faqEN: [
      { q: 'Is every puzzle solvable logically?', a: 'Yes, every board has a unique, pure logical solution.' },
      { q: 'Is it free to download?', a: 'Yes, available free on iOS App Store and Google Play.' },
    ],
    faqTR: [
      { q: 'Tüm bulmacalar mantıkla çözülebilir mi?', a: 'Evet, her bulmacanın tek bir mantıksal çözümü vardır.' },
      { q: 'İndirmek ücretsiz mi?', a: 'Evet, App Store ve Google Play’de tamamen ücretsizdir.' },
    ],
  },
  {
    slug: 'flow-connects',
    title: 'Flow Connects: Pipe Puzzle',
    shortTitle: 'Flow',
    route: '/flow-connects',
    theme: 'green',
    accent: '#10b981',
    accentSoft: '#eaf8f2',
    surface: '#062b22',
    feature: '/games/flow-connects/feature.png',
    icon: '/games/flow-connects/icon.png',
    screenshots: [
      '/games/flow-connects/screenshots/ss-1.png',
      '/games/flow-connects/screenshots/ss-2.png',
      '/games/flow-connects/screenshots/ss-3.png',
      '/games/flow-connects/screenshots/ss-4.png',
      '/games/flow-connects/screenshots/ss-5.png',
    ],
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.flowconnects.pipepuzzle',
    appStoreUrl: appStoreSearchUrl('Flow Connects Pipe Puzzle'),
    descriptionEN: 'Connect the pipes, clear the board, and keep the flow smooth across colorful levels.',
    descriptionTR: 'Boruları bağla, tahtayı temizle ve renkli bölümlerde akışı bozmadan ilerle.',
    highlightsEN: [
      'Pipe routes and satisfying connection paths',
      'Fresh green visuals with a relaxed pace',
      'A clean puzzle brand with recognizable art',
    ],
    highlightsTR: [
      'Borulu bağlantı yolları ve tatmin edici hatlar',
      'Rahat tempolu, taze yeşil görsel dil',
      'Kolay tanınan, temiz bir bulmaca markası',
    ],
    howToPlayEN: [
      'Match Color Dots: Drag from one colored dot to pair it with its matching dot.',
      'Cover 100% Grid: Draw pipe lines until every single grid square is occupied.',
      'Avoid Line Overlaps: Make sure pipe paths do not cross or break each other.',
    ],
    howToPlayTR: [
      'Aynı Renkleri Bağlayın: Aynı renkli noktaları çizgi çekerek eşleştirin.',
      'Tüm Tahtayı Kaplayın: Boruların kesişmesine izin vermeden tüm kareleri doldurun.',
      'Kusursuz Akışı Yakalayın: Çizgileri koparmadan bölümü %100 kapsama ile bitirin.',
    ],
    featuresEN: [
      { title: 'Hundreds of Vibrant Levels', desc: 'From compact 5x5 grids to sprawling 10x10 pipe mazes.' },
      { title: 'Relaxing ASMR Audio', desc: 'Soothing liquid connection sounds when completing pipe paths.' },
      { title: 'Colorblind Friendly', desc: 'Optional shape symbols alongside colors for clear vision.' },
      { title: 'Free & Offline', desc: 'No internet required to play anywhere.' },
    ],
    featuresTR: [
      { title: 'Yüzlerce Canlı Bölüm', desc: '5x5 kolay ızgaralardan 10x10 zorlu boru labirentlerine.' },
      { title: 'Rahatlatıcı Ses Efektleri', desc: 'Borular bağlandığında çalan huzur verici su sesleri.' },
      { title: 'Renk Körlüğü Modu', desc: 'Renklerin yanında özel şekiller içeren kapsayıcı mod.' },
      { title: 'Ücretsiz ve İnternetsiz', desc: 'İnternet bağlantısı olmadan istediğiniz yerde oynayın.' },
    ],
    tipsEN: [
      'Connect dots along outer edges first to preserve central board space.',
      'If lines cross, trace alternative perimeter routes.',
    ],
    tipsTR: [
      'Dış kenarlardaki noktaları öncelikle bağlayarak merkez alanı açık tutun.',
      'Çizgiler kesişiyorsa etraftan geçen alternatif rotaları deneyin.',
    ],
    faqEN: [
      { q: 'Is there a move limit?', a: 'No limit, but achieving a Perfect clear uses minimum moves.' },
      { q: 'Can I play offline?', a: 'Yes, full offline support.' },
    ],
    faqTR: [
      { q: 'Hamle sınırı var mı?', a: 'Sınır yok, fakat en az hamle ile Mükemmel skoru yakalayabilirsiniz.' },
      { q: 'İnternetsiz oynanır mı?', a: 'Evet, tamamen çevrimdışı oynanır.' },
    ],
  },
  {
    slug: 'tile-match',
    title: 'Triple Grove: Tile Match',
    shortTitle: 'Tile Match',
    route: '/tile-match',
    theme: 'warm',
    accent: '#f59e0b',
    accentSoft: '#fff2df',
    surface: '#2e1c07',
    feature: '/games/tile-match/feature.png',
    icon: '/games/tile-match/icon.png',
    screenshots: [
      '/games/tile-match/screenshots/ss-1.png',
      '/games/tile-match/screenshots/ss-2.png',
      '/games/tile-match/screenshots/ss-3.png',
      '/games/tile-match/screenshots/ss-4.png',
      '/games/tile-match/screenshots/ss-5.png',
      '/games/tile-match/screenshots/ss-6.png',
    ],
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.mkucukkoc.triplegrove',
    appStoreUrl: appStoreSearchUrl('Triple Grove Tile Match'),
    descriptionEN: 'Match three and clear the tray in a bright, cozy tile puzzle with clean store visuals.',
    descriptionTR: 'Üçlü eşleştir, tepsiyi temizle ve sıcak, parlak bir tile puzzle deneyimi yaşa.',
    highlightsEN: [
      'Cozy, collectible tile-matching presentation',
      'Warm palette that feels friendly in store galleries',
      'Easy to pair with seasonal themes later',
    ],
    highlightsTR: [
      'Sıcak ve toplanabilir tile eşleştirme sunumu',
      'Mağaza galerisinde dostça duran sıcak palet',
      'İleride sezonluk temalarla kolay eşleşir',
    ],
    howToPlayEN: [
      'Tap Tiles to Move to Tray: Tap unblocked tiles to place them into your 7-slot holding tray.',
      'Match 3 Identical Tiles: Whenever 3 matching tiles sit in the tray, they clear instantly.',
      'Clear the Layered Board: Remove all tiles from the board without letting the tray overflow.',
    ],
    howToPlayTR: [
      'Karolara Dokunun: Üstü açık karolara tıklayarak 7 bölmeli tepsiye taşıyın.',
      '3 Aynı Karoyu Eşleştirin: Tepside 3 aynı karo bir araya geldiğinde anında yok olur.',
      'Tepsinin Dolmasını Önleyin: Tepsiyi taşırmadan tüm katmanlı panoyu temizleyip kazanın.',
    ],
    featuresEN: [
      { title: 'Triple Match Mechanics', desc: 'Satisfying 3-tile matching with cozy nature & fruit themes.' },
      { title: 'Undo, Shuffle & Magnet Boosters', desc: 'Use powerful boosters when your tray is almost full.' },
      { title: 'Multi-Layered Layouts', desc: 'Deep tile stacks that test tactical foresight.' },
      { title: 'Cozy Visual Art', desc: 'Warm wooden textures, nature elements, and soothing sound effects.' },
    ],
    featuresTR: [
      { title: 'Üçlü Eşleştirme Dinamiği', desc: 'Meyve ve doğa temalı karolarla keyifli 3’lü eşleştirme.' },
      { title: 'Geri Al, Karıştır ve Mıknatıs Jokerleri', desc: 'Tepsiniz dolmak üzereyken güçlü jokerlerle oyunu kurtarın.' },
      { title: 'Katmanlı Pano Yapısı', desc: 'Derin karo kuleleri ile stratejik hamle yapma becerisi.' },
      { title: 'Sıcak Doğa Tasarımı', desc: 'Ahşap dokular, göz alıcı karolar ve huzur veren müzik.' },
    ],
    tipsEN: [
      'Prioritize unlocking tiles that reveal multiple covered underlying tiles.',
      'Keep at least 2 empty tray slots open as safety buffers.',
    ],
    tipsTR: [
      'Altında birden fazla kapalı karo barındıran üst karolara öncelik verin.',
      'Tepsinizde en az 2 boş yer bırakarak güvenlik marjı sağlayın.',
    ],
    faqEN: [
      { q: 'What happens if the tray fills up?', a: 'If all 7 tray slots are filled without forming a match, the game ends.' },
      { q: 'Is it free to play?', a: 'Yes, free with earnable booster rewards.' },
    ],
    faqTR: [
      { q: 'Tepsi dolarsa ne olur?', a: '7 bölme de eşleşme olmadan dolarsa seviye sonlanır.' },
      { q: 'Ücretsiz mi?', a: 'Evet, kazanılabilir joker ödülleriyle tamamen ücretsizdir.' },
    ],
  },
  {
    slug: 'color-sort',
    title: 'Color Sort: Water Puzzle',
    shortTitle: 'Color Sort',
    route: '/color-sort',
    theme: 'cyan',
    accent: '#06b6d4',
    accentSoft: '#e0f2fe',
    surface: '#082f49',
    feature: '/games/color-sort/feature.png',
    icon: '/games/color-sort/icon.png',
    screenshots: [
      '/games/color-sort/screenshots/ss-1.png',
      '/games/color-sort/screenshots/ss-2.png',
      '/games/color-sort/screenshots/ss-3.png',
      '/games/color-sort/screenshots/ss-4.png',
      '/games/color-sort/screenshots/ss-5.png',
    ],
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.puzzle.colorsort',
    appStoreUrl: appStoreSearchUrl('Color Sort Water Puzzle'),
    descriptionEN: 'Pour and sort colored liquids into tubes until each bottle holds a single uniform color.',
    descriptionTR: 'Renkli sıvıları tüplere dökerek her şişede tek renk elde edene kadar sıvıları eşleştir.',
    highlightsEN: [
      'Vibrant liquid sorting puzzle mechanics',
      'Relaxing water pouring animations and sounds',
      'Hundreds of brain-teasing tube levels',
    ],
    highlightsTR: [
      'Canlı sıvı sıralama bulmaca mekaniği',
      'Rahatlatıcı su dökme animasyonları ve sesleri',
      'Yüzlerce zihin açıcı tüp seviyesi',
    ],
    howToPlayEN: [
      'Tap a Tube: Select any bottle to pour liquid from top layer into another tube.',
      'Match Same Colors: You can only pour liquid if both tubes have matching top colors.',
      'Sort All Tubes: Complete the puzzle when every tube contains only one solid color.',
    ],
    howToPlayTR: [
      'Tüpe Dokunun: Üst katmandaki sıvıyı başka bir tüpe dökmek için şişeyi seçin.',
      'Aynı Renkleri Eşleştirin: Sıvıyı sadece hedef tüpün üstündeki renk aynıysa dökebilirsiniz.',
      'Tüm Tüpleri Sıralayın: Her tüp tek bir renk içerdiğinde bulmacayı çözün.',
    ],
    featuresEN: [
      { title: '1,000+ Liquid Levels', desc: 'From simple 3-tube setups to complex multi-color challenges.' },
      { title: 'Relaxing ASMR Sound', desc: 'Soothing water pouring effects and smooth fluid motion.' },
      { title: 'Undo & Extra Tube Boosters', desc: 'Get unstuck easily by adding an extra empty tube or rewinding moves.' },
      { title: 'Offline Play', desc: 'Enjoy relaxing color sorting anytime without internet.' },
    ],
    featuresTR: [
      { title: '1.000+ Sıvı Seviyesi', desc: '3 tüplü kolay bulmacalardan çok renkli zorlu seviyelere.' },
      { title: 'Rahatlatıcı Su Sesleri', desc: 'Huzur veren su dökme efektleri ve akıcı sıvı animasyonları.' },
      { title: 'Geri Al ve Ekstra Tüp Jokerleri', desc: 'Ekstra boş tüp ekleyerek veya hamleyi geri alarak rahatça çözün.' },
      { title: 'İnternetsiz Oynama', desc: 'İnternet bağlantısı olmadan istediğiniz yerde renkleri sıralayın.' },
    ],
    tipsEN: [
      'Always keep at least one tube empty as a workspace buffer.',
      'Prioritize completing single-color bottles first to free up tube capacity.',
    ],
    tipsTR: [
      'İşlem marjı sağlamak için en az bir tüpü her zaman boş tutmaya çalışın.',
      'Öncelikle tek renkli şişeleri tamamlayarak tüp kapasitesini açın.',
    ],
    faqEN: [
      { q: 'Is Color Sort free to play?', a: 'Yes, completely free with optional hint boosters.' },
      { q: 'Does it work offline?', a: 'Yes, full offline support is included.' },
    ],
    faqTR: [
      { q: 'Color Sort ücretsiz mi?', a: 'Evet, isteğe bağlı joker ödülleriyle tamamen ücretsizdir.' },
      { q: 'İnternetsiz çalışıyor mu?', a: 'Evet, tam çevrimdışı oynanabilir.' },
    ],
  },
  {
    slug: 'word-connect',
    title: 'Word Connect: Crossword Quest',
    shortTitle: 'Word Connect',
    route: '/word-connect',
    theme: 'amber',
    accent: '#d97706',
    accentSoft: '#fef3c7',
    surface: '#2e1c05',
    feature: '/games/word-connect/feature.png',
    icon: '/games/word-connect/icon.png',
    screenshots: [
      '/games/word-connect/screenshots/ss-1.png',
      '/games/word-connect/screenshots/ss-2.png',
      '/games/word-connect/screenshots/ss-3.png',
      '/games/word-connect/screenshots/ss-4.png',
      '/games/word-connect/screenshots/ss-5.png',
    ],
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.puzzle.wordconnect',
    appStoreUrl: appStoreSearchUrl('Word Connect Crossword Quest'),
    descriptionEN: 'Swipe letter wheels to connect letters and solve relaxing crossword puzzles.',
    descriptionTR: 'Dairesel harf çarkından parmağınızı kaydırıp harfleri birleştirin, bulmacaları çözün.',
    highlightsEN: [
      'Circular letter wheel swipe mechanics',
      'Expanding crossword grid puzzles',
      'Thousands of vocabulary-building levels',
    ],
    highlightsTR: [
      'Dairesel harf çarkından kelime birleştirme',
      'Genişleyen karemaca ızgara bulmacaları',
      'Kelime dağarcığını geliştiren binlerce seviye',
    ],
    howToPlayEN: [
      'Swipe to Connect Letters: Drag your finger across the letter wheel to form words.',
      'Fill Crossword Grid: Solve all horizontal and vertical words to clear the stage.',
      'Discover Extra Bonus Words: Find hidden extra words to earn bonus coin rewards.',
    ],
    howToPlayTR: [
      'Harfleri Parmağınızla Bağlayın: Kelimeleri oluşturmak için çarktaki harfler üzerinde sürükleyin.',
      'Karemaca Izgarayı Doldurun: Tüm yatay ve dikey kelimeleri bularak seviyeyi geçin.',
      'Bonus Kelimeler Bulun: Gizli ekstra kelimeleri bularak ekstra ödül kazanın.',
    ],
    featuresEN: [
      { title: '2,000+ Word Levels', desc: 'Starting from easy 3-letter words up to challenging 7-letter crosswords.' },
      { title: 'Relaxing Scenery Themes', desc: 'Calm ambient backgrounds and pleasant soundscapes.' },
      { title: 'Free Hints & Shuffle', desc: 'Use shuffle and hint boosters whenever you need inspiration.' },
      { title: 'Full Offline Support', desc: 'Play word connect anytime without internet.' },
    ],
    featuresTR: [
      { title: '2.000+ Kelime Seviyesi', desc: '3 harfli kolay kelimelerden 7 harfli zorlu bulmacalara.' },
      { title: 'Dinlendirici Manzara Temaları', desc: 'Gözü yormayan renkler ve rahatlatıcı arka planlar.' },
      { title: 'İpucu ve Karıştırma', desc: 'Zorlandığınızda harfleri karıştırın veya ipucu jokerlerini kullanın.' },
      { title: 'Çevrimdışı Oynama', desc: 'İnternet bağlantısı gerektirmeden her yerde kelime avı.' },
    ],
    tipsEN: [
      'Focus on finding root words first to unlock connecting crossword positions.',
      'Shuffle the letter wheel if your eyes get stuck on the current letter order.',
    ],
    tipsTR: [
      'Öncelikle ızgarayı açacak kilit kelimeleri bulmaya odaklanın.',
      'Takıldığınız an harf çarkını karıştırarak farklı açılardan bakın.',
    ],
    faqEN: [
      { q: 'Is Word Connect free to play?', a: 'Yes, completely free with earnable hint coins.' },
      { q: 'Can I play offline?', a: 'Yes, full offline play is supported.' },
    ],
    faqTR: [
      { q: 'Word Connect ücretsiz mi?', a: 'Evet, tamamen ücretsizdir.' },
      { q: 'İnternetsiz oynanabilir mi?', a: 'Evet, internetsiz oynanabilir.' },
    ],
  },
  {
    slug: 'screw-master',
    title: 'Screw Master: Nuts & Bolts',
    shortTitle: 'Screw Master',
    route: '/screw-master',
    theme: 'orange',
    accent: '#ea580c',
    accentSoft: '#ffedd5',
    surface: '#2d1205',
    feature: '/games/screw-master/feature.png',
    icon: '/games/screw-master/icon.png',
    screenshots: [
      '/games/screw-master/screenshots/ss-1.png',
      '/games/screw-master/screenshots/ss-2.png',
      '/games/screw-master/screenshots/ss-3.png',
      '/games/screw-master/screenshots/ss-4.png',
      '/games/screw-master/screenshots/ss-5.png',
    ],
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.puzzle.screwmaster',
    appStoreUrl: appStoreSearchUrl('Screw Master Nuts Bolts'),
    descriptionEN: 'Unscrew pins and bolts in the right sequence to drop plates in satisfying ASMR style.',
    descriptionTR: 'Vidaları ve somunları doğru sırayla söküp plakaları düşürün, ASMR rahatlamasını yaşayın.',
    highlightsEN: [
      'Satisfying unscrewing mechanics & ASMR physics',
      'Realistic wooden and metallic plate puzzles',
      'Hundreds of logic-testing pin stages',
    ],
    highlightsTR: [
      'Tatmin edici vida sökme ve ASMR fizik hissi',
      'Gerçekçi ahşap ve metal plaka bulmacaları',
      'Zeka zorlayan yüzlerce vida bölümü',
    ],
    howToPlayEN: [
      'Tap a Screw: Select a pin/screw to unscrew it from the wooden plate.',
      'Place in Open Hole: Move the screw into an unoccupied hole on the board.',
      'Drop All Plates: Free all overlapping plates to clear the level successfully.',
    ],
    howToPlayTR: [
      'Vidaya Dokunun: Sökmek istediğiniz vidayı seçin.',
      'Boş Deliğe Yerleştirin: Sökülen vidayı tahtadaki boş bir yuvaya aktarın.',
      'Tüm Plakaları Düşürün: Üst üste binen tüm tahta/metal plakaları düşürerek seviyeyi bitirin.',
    ],
    featuresEN: [
      { title: '1,500+ Screw Levels', desc: 'From simple 2-bolt tasks to multi-layered mechanical challenges.' },
      { title: 'Relaxing ASMR Haptics', desc: 'Tactile vibration and realistic metallic unscrewing audio.' },
      { title: 'Screwdriver & Hole Boosters', desc: 'Unlock extra screw holes when you get jammed.' },
      { title: 'Offline Friendly', desc: 'No internet required to enjoy screw puzzles anywhere.' },
    ],
    featuresTR: [
      { title: '1.500+ Vida Seviyesi', desc: '2 vidalı basit bulmacalardan katmanlı mekanik tasarımlara.' },
      { title: 'ASMR Ses ve Titreşim', desc: 'Gerçekçi metalik sökülme sesleri ve dokunsal geri bildirim.' },
      { title: 'Ekstra Delik Jokerleri', desc: 'Tıkandığınız anlarda tahtaya yeni boş vida yuvası ekleyin.' },
      { title: 'İnternetsiz Oynama', desc: 'İnternet bağlantısı olmadan istediğiniz yerde oynayın.' },
    ],
    tipsEN: [
      'Examine overlapping plate layers before unscrewing key structural pins.',
      'Prioritize freeing bottom plates first if top screws block lower movement.',
    ],
    tipsTR: [
      'Kilit vidaları sökmeden önce hangi plakanın diğerini tuttuğunu inceleyin.',
      'Öncelikle serbest kalan plakaların düşmesini sağlayarak alan açın.',
    ],
    faqEN: [
      { q: 'Is Screw Master free to play?', a: 'Yes, completely free with earnable boosters.' },
      { q: 'Does it support offline mode?', a: 'Yes, offline mode is fully supported.' },
    ],
    faqTR: [
      { q: 'Screw Master ücretsiz mi?', a: 'Evet, tamamen ücretsizdir.' },
      { q: 'İnternetsiz çalışıyor mu?', a: 'Evet, tam çevrimdışı oynanabilir.' },
    ],
  },
];

export const GAME_MAP = Object.fromEntries(GAMES.map(game => [game.slug, game]));

export const getGameBySlug = slug => GAME_MAP[slug] ?? GAMES[0];
